import { useTranslation } from '@cobliteam/i18n';
import { FormControl, FormField, FormItem, FormMessage, Input, useFormContext } from '@cobliteam/ui/form';

import type { FormValues } from '../../checklistSchema';

interface ChecklistItemTitleProps {
  index: number;
}

const ChecklistItemTitle = ({ index }: ChecklistItemTitleProps) => {
  const { t } = useTranslation('checklists');
  const { control } = useFormContext<FormValues>();

  return (
    <FormField control={control} name={`items.${index}.title`}>
      {({ field, formState }) => (
        <FormItem>
          <FormControl>
            <Input {...field} placeholder={t('type_your_question')} error={!!formState.errors.items?.[index]?.title} />
          </FormControl>
          {!!formState.errors.items?.[index]?.title && <FormMessage />}
        </FormItem>
      )}
    </FormField>
  );
};

export default ChecklistItemTitle;
